import { AfterViewInit, Component, ElementRef, Self } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: "lib-data-table-tooltip",
  templateUrl: "./tooltip-cell-renderer.component.html",
  styleUrls: ["./tooltip-cell-renderer.component.scss"]
})
export class TooltipCellRendererComponent implements ICellRendererAngularComp, AfterViewInit {
  constructor( @Self() private element: ElementRef ) {}
  
  public params: any;
  public overflow: boolean = true;

  public agInit(params: any): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }

  ngAfterViewInit(): void {
    // Wait until event cycle finishes to detect if overflow occurs
    setTimeout(() => {
      // Get the span text, which is hidden in the first place
      // Compare scrollWidth and offsetWidth to check if text overflowed as it's more reliable than button
      let headerSpan = this.element.nativeElement.querySelector('span.data-table__content');
      if (headerSpan) {
        // Clone the element to check the width
        let cln = headerSpan.cloneNode(true);
        cln.removeAttribute("hidden");
        // Append the cloned element to calculate the scrollWidth and offsetWidth
        headerSpan.parentNode.appendChild(cln);
        this.overflow = cln.scrollWidth > cln.offsetWidth;
        // Remove afterwards
        cln.remove();
      }
    }, 0);
  }
}
